import React, { useState, useEffect } from 'react'
import {
  ProgressBar
} from 'react-bootstrap';
import Truncate from 'react-truncate';
import _ from 'lodash';
import cx from 'classnames';
import { IKImage } from "imagekitio-react";
import { DEFAULT, DOCUMENT, VIDEO } from 'constants/widgetAssetTypes';
import dateformat from "dateformat";
import Tooltip from 'components/Tooltip';
import FileService from 'services/file.service';
import styles from './components.module.scss';
import { INTERACTIVE_CONTENT_TYPES } from 'constants/storyboardType';


const defaultContentImage = '/public/cleverstory/v2/static/default_card.jpg';

export const ContentCard = ({ assetMapping, key, id, selected, onClick, allowType}) => {

  const icon = _.get(assetMapping, 'asset.icon.key', null) || _.get(assetMapping, 'asset.icon.url', null);
  const [tooltip, setTooltip] = useState(false)
  const metaData = _.get(assetMapping, 'asset.metadata');
  const fileType = _.get(assetMapping, 'asset.metadata.content_type');
  const deleting = _.get(assetMapping, 'deleting');

  let isFileTypeIncluded = checkTypes(metaData, allowType);


  const handleAssetSection = (e) => {
    if( isFileTypeIncluded ){
     
      const id = _.get(assetMapping, 'id', null);
      const type = _.get(assetMapping, 'entityType', null);
      if (!id || deleting) {
        return;
      }

      onClick(e, assetMapping);
    }
  }

  const renderAssetName = () => {
    const type = _.get(assetMapping, 'entityType');

    switch (type) {
      case 'asset':
        return _.get(assetMapping, 'asset.name', '');
      case 'url':
        return _.get(assetMapping, 'url', '');
      case 'file':
        return _.get(assetMapping, 'file.name', '');
      case 'page':
        return _.get(assetMapping, 'asset.name', '');
      default:
        return "";
    }
  }

  const name = renderAssetName();

  const handleTooltip = (truncated) => {
    setTooltip(truncated);
  }

  return (
    <div key={key} id={id} onClick={handleAssetSection} className={cx(styles.assetCardWrapper, 'cs-asset-card', { ['cs-selected-asset-card']: selected }, {
      [styles.selected]: selected
    }, { [styles.isDisabled]: !isFileTypeIncluded } )}>

      <div className={cx(styles.iconWrapper, styles.journeyIconWrapper)}>
        {(icon || defaultContentImage) && 
          <IKImage
          className={cx(styles.icon, styles.journeyIcon)}
          path={icon || defaultContentImage}
        />
        }
      </div>
      <div className={cx(styles.detailsContainer, styles.journeyDetailsContainer)}>
        {name &&
          <Tooltip placement="top" content={name} disabled={!tooltip} className={styles.tooltip}>
            <span className={cx(styles.name, styles.journeyName)}>
              <Truncate onTruncate={handleTooltip} lines={1}>
                  {name}
              </Truncate>
            </span>
          </Tooltip>
        }
        <ContentMetadata content={assetMapping} />
      </div>
    </div>
  )
}

export const ContentMetadata = ({ content, className }) => {
  const metaData = _.get(content, 'asset.metadata', {})

  const modified_date = _.get(content, 'modifiedDate') || _.get(metaData, 'modified_date');

  let storyboardType = _.get(content, 'asset.storyboardType');
  
  const renderStoryboardType = (type) => {
    if (type === 'LANDING_PAGE') {
      return 'Landing page';
    } else if (INTERACTIVE_CONTENT_TYPES.includes(type)) {
      return 'Interactive content';
    } else if (type === 'RESOURCE_CENTER') {
      return 'Resource center';
    }
    else {
      return 'Spatial';
    }
  }

  return (
    <div className={cx(styles.metaData, styles.journeyMetaData)}>
      <div className={styles.details}>
        <div className={styles.type}>
          {(_.get(content, 'asset.entityType') === 'asset' || _.get(content, 'entityType') === 'asset' ) &&
            <>
              <i className={cx(styles.fileIcon, `${FileService.fileIcon(metaData)}`)} />
              <span className={styles.textFormat} >{FileService.fileType(metaData)}</span>
            </>
          }
          {(_.get(content, 'asset.entityType') === 'page' || _.get(content, 'entityType') === 'page' ) &&
            <>
              <i className={cx(styles.fileIcon, `${FileService.storyboardIcon(storyboardType)}`)} />
              <span className={styles.storyboardTextFormat} >{renderStoryboardType(storyboardType)}</span>
            </>
          }
        </div>
      </div>
      <div className={cx(styles.date, styles.journeyDate)}>{dateformat(modified_date, 'dd mmm yyyy')}</div>
    </div>
  );
}

export const ContentCardPlaceholder = () => {
  return (
    <div className={cx(styles.contentCard, styles.placeholder)}>
      <div className={cx(styles.iconWrapper)}></div>
      <div className={styles.detailsContainer}>
        <div className={styles.name}>
          <span>&nbsp;</span>
          <span>&nbsp;</span>
        </div>
        <div className={cx(styles.contentMetadata)}>
          {_.times(2).map(index => {
            return (
              <div key={index} className={styles.metadata}><span>&nbsp;</span></div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

function checkTypes(metaData, allowType) {
  const videoTypes = ["VIDEO", "YOUTUBE", "VIMEO", "WISTIA", "VIDYARD"];
  const documentTypes = ["PDF", "PPTX", "PPT", "DOC", "DOCX"];
  
  if (!metaData || !allowType) {
    return true;
  }

  const file_type = FileService.fileType(metaData);

  const isVideo = allowType === VIDEO || allowType === DEFAULT;
  const isDocument = allowType === DOCUMENT;

  if (isVideo) {
    return videoTypes.includes(file_type);
  } else if (isDocument) {
    return documentTypes.includes(file_type);
  } else {
    return true;
  }
}


